<template>

    <div :class="classes">
        <span>{{ $t('labels.new') }}</span>
    </div>

</template>

<style scoped lang="scss">

    .badge {
        @include font-bold(9px);
        align-items: center;
        border-radius: 5px;
        color: $color-white;
        display: flex;
        justify-content: center;
        line-height: normal;
        text-transform: uppercase;
        &.badge-sm {
            font-size: 8px;
            height: 18px;
            padding: 0 6px;
        }
        &.badge-md {
            font-size: 9px;
            height: 24px;
            padding: 0 10px;
        }
        &.badge-primary {
            background-color: $color-primary;
        }
        &.badge-success {
            background-color: $color-success;
        }
    }

</style>

<script>

import moment from 'moment';

export default {

    props: {
        date: {
            type: String,
            validator: function(value) {
                return /^\d{4}-\d{2}-\d{2}$/.test(value);
            },
        },
        size: {
            type: String,
            default: 'md',
        },
        type: {
            type: String,
            default: 'success',
            validator: function(value) {
                return value === 'primary' || value === 'success';
            },
        },
    },

    data() {
        return {
            daysVisible: 60,
        }
    },

    computed: {

        classes() {
            return {
                'badge': true,
                'badge-md': this.size === 'md',
                'badge-sm': this.size === 'sm',
                'badge-primary': this.type === 'primary',
                'badge-success': this.type === 'success',
                'd-none': !this.valid,
            };
        },

        valid() {
            if (!this.date) return true;
            return Math.abs(moment().diff(moment(this.date), 'days')) <= this.daysVisible;
        },

    },

}

</script>
